export default __webpack_public_path__ + "static/media/close_ic.63d0f697.svg";